import { merge } from "lodash";

import Button from "./Button";
import Table from "./Table";
import Card from "./Card";
import ButtonBase from "./ButtonBase";
import ToggleButton from "./ToggleButton";
import Tooltip from "./Tooltip";

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
    return merge(
        Table(theme),
        Button(theme),
        ButtonBase(theme),
        Card(theme),
        ToggleButton(theme),
        Tooltip(theme),
    );
}
